module.exports = __webpack_public_path__ + "media/application/images/img/lightbox/default-skin-e3f799c6dec9af194c86decdf7392405.png";